import React, { useEffect } from 'react';
import SeoMeta from '../components/SeoMeta';
import PageHero from '../components/ui/PageHero';
import SectionHeader from '../components/ui/SectionHeader';
import './PrivacyPolicy.css';
import heroImage from '../assets/HeroPol.webp';

const PrivacyPolicy = () => {
  const ogTitle = 'Политика конфиденциальности LSTK Production';
  const ogDescription = 'Порядок обработки и защиты персональных данных пользователей сайта LSTK Production.';

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <div className="privacy-policy-page">
      <SeoMeta
        title={ogTitle}
        description={ogDescription}
        image="https://fk-alatau.kz/og/main.jpg"
      />
      <PageHero
        title="Политика конфиденциальности"
        subtitle="Обработка и защита персональных данных пользователей сайта"
        meta="Industrial Premium • Политика"
        image={heroImage}
      />

      <section className="privacy-policy-section">
        <div className="container">
          <SectionHeader
            eyebrow="Документ"
            title="Политика конфиденциальности"
            subtitle="Порядок обработки и защиты персональных данных"
          />

          <div className="privacy-policy-content">
            <h2 className="h2">ПОЛИТИКА КОНФИДЕНЦИАЛЬНОСТИ</h2>
            <p className="body-md">
              Настоящая Политика конфиденциальности определяет порядок обработки и
              защиты персональных данных пользователей сайта Фабрика Каркасов
              Алатау (далее — «Сайт»).
            </p>
            <p className="body-md">
              Используя Сайт, включая просмотр страниц, отправку заявок,
              обращение через формы обратной связи, мессенджеры или иные каналы
              связи, Пользователь выражает согласие с условиями настоящей
              Политики.
            </p>

            <h3 className="h3">1. Общие положения</h3>
            <p className="body-md">
              1.1. Сайт носит информационный характер и предназначен для
              ознакомления с направлениями деятельности, решениями и услугами
              компании в сфере проектирования и строительства объектов на базе
              ЛСТК.
            </p>
            <p className="body-md">
              1.2. Настоящая Политика применяется исключительно к Сайту.
              Администрация Сайта не несёт ответственности за сайты третьих лиц,
              на которые Пользователь может перейти по внешним ссылкам.
            </p>

            <h3 className="h3">2. Персональные данные Пользователей</h3>
            <p className="body-md">
              2.1. В рамках использования Сайта могут обрабатываться следующие
              персональные данные Пользователя:
            </p>
            <ul className="privacy-policy-list">
              <li className="body-md">– имя (при указании);</li>
              <li className="body-md">– номер телефона;</li>
              <li className="body-md">– адрес электронной почты;</li>
              <li className="body-md">– содержание сообщения или запроса;</li>
              <li className="body-md">– иные данные, предоставленные Пользователем добровольно.</li>
            </ul>
            <p className="body-md">
              2.2. Также автоматически могут обрабатываться обезличенные
              технические данные:
            </p>
            <ul className="privacy-policy-list">
              <li className="body-md">– IP-адрес;</li>
              <li className="body-md">– тип браузера и устройства;</li>
              <li className="body-md">– сведения о посещённых страницах;</li>
              <li className="body-md">– дата и время доступа.</li>
            </ul>

            <h3 className="h3">3. Цели обработки персональных данных</h3>
            <p className="body-md">
              3.1. Персональные данные Пользователей обрабатываются исключительно
              в следующих целях:
            </p>
            <ul className="privacy-policy-list">
              <li className="body-md">– обработка обращений и заявок;</li>
              <li className="body-md">– связь с Пользователем;</li>
              <li className="body-md">– подготовка расчётов и коммерческих предложений;</li>
              <li className="body-md">– предоставление информации об услугах и решениях компании;</li>
              <li className="body-md">– улучшение работы Сайта.</li>
            </ul>
            <p className="body-md">
              3.2. Персональные данные не используются для автоматических
              рассылок без согласия Пользователя и не передаются третьим лицам,
              за исключением случаев, предусмотренных законодательством.
            </p>

            <h3 className="h3">4. Условия обработки и хранения данных</h3>
            <p className="body-md">
              4.1. Обработка персональных данных осуществляется с использованием
              средств автоматизации или без таковых.
            </p>
            <p className="body-md">
              4.2. Персональные данные хранятся не дольше, чем это необходимо для
              достижения целей их обработки.
            </p>
            <p className="body-md">
              4.3. Администрация Сайта принимает разумные организационные и
              технические меры для защиты персональных данных от
              несанкционированного доступа, утраты или разглашения.
            </p>

            <h3 className="h3">5. Права Пользователя</h3>
            <p className="body-md">5.1. Пользователь вправе:</p>
            <ul className="privacy-policy-list">
              <li className="body-md">– запросить информацию о своих персональных данных;</li>
              <li className="body-md">– потребовать их уточнения или удаления;</li>
              <li className="body-md">– отозвать согласие на обработку персональных данных.</li>
            </ul>
            <p className="body-md">
              5.2. Для реализации своих прав Пользователь может направить
              обращение по контактным данным, указанным на Сайте.
            </p>

            <h3 className="h3">6. Ограничение ответственности</h3>
            <p className="body-md">6.1. Администрация Сайта не несёт ответственности за:</p>
            <ul className="privacy-policy-list">
              <li className="body-md">– предоставление Пользователем недостоверных данных;</li>
              <li className="body-md">– действия третьих лиц;</li>
              <li className="body-md">– временную недоступность Сайта.</li>
            </ul>
            <p className="body-md">
              6.2. Использование Сайта осуществляется Пользователем добровольно
              и на свой риск.
            </p>

            <h3 className="h3">7. Изменение Политики конфиденциальности</h3>
            <p className="body-md">
              7.1. Администрация Сайта вправе вносить изменения в настоящую
              Политику без предварительного уведомления Пользователей.
            </p>
            <p className="body-md">
              7.2. Актуальная версия Политики всегда доступна на Сайте.
            </p>

            <h3 className="h3">8. Заключительные положения</h3>
            <p className="body-md">
              8.1. Настоящая Политика конфиденциальности регулируется действующим
              законодательством Республики Казахстан.
            </p>
            <p className="body-md">
              8.2. Все вопросы, связанные с обработкой персональных данных,
              направляются по контактным данным, указанным на Сайте.
            </p>

            <p className="body-md">Владелец сайта: Фабрика Каркасов Алатау</p>
            <p className="body-md privacy-policy-date">Дата публикации: 2025</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
